import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SearchModalComponent } from './search-modal.component';
import { CardPageModule } from '../card/card.module';

@NgModule({
	imports: [
		CommonModule,
		IonicModule,
		CardPageModule,
	],
	declarations: [SearchModalComponent],
	exports: [SearchModalComponent],
})
export class SearchModalModule {}
